import React, {useState} from "react";
import './Maintenance.scss'

import TeacherLoadContainer from "root/s360components/TeacherLoad/TeacherLoadContainer";
import UserEditContainer from "root/s360components/UserRename/UserEditContainer";
import MisStatusToolContainer from "root/s360components/WondeWebhookAdmin/MisStatusToolContainer";
import {Col, Nav, NavItem, Row, Tab} from "react-bootstrap";

const MaintenancePage = (props) =>
{

    return (
        <Tab.Container id="tabs-with-dropdown" defaultActiveKey="first" className="maintenance-wrapper">
            <Row className="clearfix">
                <Col sm={12}>
                    <Nav bsStyle="tabs">
                        <NavItem eventKey="first">Non-Teacher Load</NavItem>
                        <NavItem eventKey="second">Edit Username</NavItem>
                        {/*<NavItem disabled eventKey="third">Wonde Webhooks</NavItem>*/}
                    </Nav>
                </Col>
                <Col sm={12}>
                    <Tab.Content animation>
                        <Tab.Pane mountOnEnter={true} eventKey="first" className='sys-admin-item' ><TeacherLoadContainer /></Tab.Pane>
                        <Tab.Pane mountOnEnter={true} eventKey="second" className='sys-admin-item'><UserEditContainer /></Tab.Pane>
                        {/*<Tab.Pane mountOnEnter={true} eventKey="third" className='sys-admin-item'><MisStatusToolContainer /></Tab.Pane>*/}

                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    )
};

export default MaintenancePage;
